import * as gfunctions from './generalFunctions';

CCL.removeFromCart = {
  autoload: [
    ['removeFromCart', $('.c-cart').length > 0]
  ],

  removeFromCart() {
    $('.c-cart').on('click', '.btn-remove-from-cart', (event) => {
      const presalesid = $(event.target).data('presalesid');
      if (presalesid) {
        const getProductDiv = `.card-${presalesid}`;
        $(getProductDiv).css('display', 'none');
      }
      this.ajaxForRemove(event);
    });
  },

  ajaxForRemove(event) {
    gfunctions.showLoader();
    const productId = $(event.target).data('productid');
    const token = $('#csrfSessionToken').data('csrf');
    const spaResHoldId = $(event.target).data('sparesholdid');
    const presalesid = $(event.target).data('presalesid');
    const shoreex = $(event.target).data('shoreex');
    const wishList2Entry = $(event.target).data('wishlist2entry');
    const backToCart = $(event.target).hasClass('backToCart');
    const dataObj = {
      productId
    };
    if (spaResHoldId) {
      dataObj.spaResHoldId = spaResHoldId;
    }
    if (presalesid) {
      dataObj.preSalesId = presalesid.toString();
    }

    if (shoreex) {
      dataObj.shoreExProduct = true;
    }

    if (wishList2Entry) {
      /* eslint-disable */
      ga('send', 'event', 'Save For later', 'Remove from Save for Later', productId, 1);
      /* eslint-enable */
      dataObj.wishList2Entry = true;
    }

    $.ajax({
      type: 'POST',
      url: '/shop/cart/entry/execute-action/REMOVE',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      gfunctions.hideLoader();
      // Check cruise cash 500 limit on cart
      if ($(event.target).parents('.c-cart-card').find('.cruise-cash-qty-increment-btn').length) {
        CCL.cartCard.cartCruiseCashRestrictUser();
      }
      if (presalesid) {
        this.updateCart(response, presalesid, backToCart);
        this.showRemovedGuests(presalesid, response);
      } else if (spaResHoldId) {
        this.updateCart(response, spaResHoldId, backToCart);
      } else {
        this.updateCart(response, productId, backToCart);
      }

      // SAS Event for remove
      gfunctions.sasEvents('send', response.cclSasAnalyticsJsonData);

      console.log('Remove from cart success');
      // Update All products again once one product is removed
      CCL.saveForLaterObj.loadSaveForLaterCartSection();
      // Below is commented to conflict of spa n shoreEx on save for later
      // CCL.editCartStateroom.createStateroomHtml();

      // update cart carousel
      if ($('body').find('.cart-carousel').length && !wishList2Entry) {
        // update cart carousel
        CCL.cartCard.updateCartCarousel();
      }

      $('.c-cart-cards .c-cart-card').each((i, e) => {
        const increment = $(e).find('.increment-btn-1');
        if (increment.length) {
          setTimeout(() => {
            CCL.pdpSf.disIncrement(increment);
          }, 2000);
        }
      });
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('Remove from cart error');
    });
  },

  updateCart(response, id, backToCart = false) {
    if (response.removeSuccess) {
      const { orderSummary } = response;

      if (backToCart) {
        const titleHtml = $(`#saveForLaterCartSection .card-${id} .title`).html();
        $(`#saveForLaterCartSection .card-${id}`).empty();
        $(`#saveForLaterCartSection .card-${id}`).css('min-height', '100px');
        $(`#saveForLaterCartSection .card-${id}`).html(`${titleHtml} has been moved to your shopping cart.`).addClass('removed-card');
      } else {
        $(`.card-${id}`).remove();
      }

      const noOfCards = $('#saveForLaterCartSection .c-cart-card:not(.removed-card)').length;
      const msg = noOfCards > 0 ? `${noOfCards} ITEM(S) SAVED FOR LATER` : 'NO ITEM(S) SAVED FOR LATER';
      $('#saveForLaterCartSection .cart-page-title').html(msg);

      gfunctions.updateHeaderCartWidget(response);
      gfunctions.updateCartSummary(orderSummary);
      gfunctions.updateProductSummary(orderSummary);
      if (response.cartEmpty) {
        window.location.reload();
      }
    }

    if (response.couponDetails) {
      gfunctions.updateCouponSummary(response);
    } else {
      $('.promo-code').show();
      $('.apply-promo').removeClass('show');
      $('.apply-promo-container').hide();
      $('.another-promo').hide();
      $('.apply-promo-container .error-msg').hide();
      $('.promo-added').hide();
    }
  },

  async showRemovedGuests(productId, data) {
    gfunctions.showLoader();
    const ajaxUrl = '/_ui/responsive/ccl/assets/templates/airport-transfers/edit-guest-airport-transfers.html';
    try {
      const inputDataObj = {
        url: ajaxUrl,
        type: 'GET'
      };
      const res = await gfunctions.doAjax(inputDataObj);
      gfunctions.hideLoader();
      const timeSlots = data.timeSlotsCard;
      for (let i = 0; i < timeSlots.length; i++) {
        const presales = timeSlots[i].transferInformation.preSaleId;
        timeSlots[i].transferInformation.productId = data.productCard.productId;
        const bookingData = timeSlots[i];
        const html = gfunctions.createDynamicHTML(res, bookingData);
        const repanitClass = `.edit-guest-snorkel-wrap.edit-guest-transfers-${presales}`;
        $(repanitClass).empty().append(html);
        const $imgArrowIcon = $(`.c-cart-card.card-transfers.card-${presales}`).find('.list-item.edit-guest-snorkel-link');
        $imgArrowIcon.removeClass('open');
        $(repanitClass).attr('style', 'display:none');
      }
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/remove-from-cart.js